import { DateTime } from "luxon";
import {
  CAR_RENTAL_FILTERS_CHANGE,
  CAR_RENTAL_FILTERS_RESET,
  CAR_RENTAL_FILTERS_UPDATE,
  CAR_RENTAL_SEARCH_FORM_CHANGE,
  CAR_RENTAL_SEARCH_FORM_RESET,
  CAR_RENTAL_SEARCH_FORM_UPDATE,
  CAR_RENTAL_SEARCH_RESULTS_CHANGE,
  CAR_RENTAL_SEARCH_RESULTS_IDLE,
  CAR_RENTAL_SEARCH_RESULTS_LOADING,
  CAR_RENTAL_SEARCH_RESULTS_RESET,
  CAR_RENTAL_SEARCH_RESULTS_UPDATE,
  CAR_RENTAL_SINGLE_FILTER_RESET,
  SELECTED_CAR_RENTAL_CHANGE,
  SELECTED_CAR_RENTAL_IDLE,
  SELECTED_CAR_RENTAL_LOADING,
  SELECTED_CAR_RENTAL_RESET,
  SELECTED_CAR_RENTAL_UPDATE,
} from "../actions/search/types";

const CarRentalSearchFormInitial = {
  pick_up_point: {},
  drop_off_point: {},
  pick_up_date: DateTime.now().plus({ days: 1 }).toISO(),
  drop_off_date: DateTime.now().plus({ days: 2 }).toISO(),
  differentDropOff: false,
  driver_nationality: "",
  driver_age: "",
};
export const CarRentalSearchForm = (
  state = CarRentalSearchFormInitial,
  action
) => {
  switch (action.type) {
    case CAR_RENTAL_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case CAR_RENTAL_SEARCH_FORM_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case CAR_RENTAL_SEARCH_FORM_RESET: {
      return CarRentalSearchFormInitial;
    }
    default:
      return state;
  }
};

const CarRentalSearchResultsInitial = {
  car_rentals: [],
  count: 0,
  api_uid: null,
  loading: false,
  failed: false,
};
export const CarRentalSearchResults = (
  state = CarRentalSearchResultsInitial,
  action
) => {
  switch (action.type) {
    case CAR_RENTAL_SEARCH_RESULTS_LOADING: {
      return { ...state, loading: true };
    }
    case CAR_RENTAL_SEARCH_RESULTS_IDLE: {
      return { ...state, loading: false };
    }
    case CAR_RENTAL_SEARCH_RESULTS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case CAR_RENTAL_SEARCH_RESULTS_UPDATE: {
      const { results } = action;
      return { ...state, ...results };
    }
    case CAR_RENTAL_SEARCH_RESULTS_RESET: {
      return CarRentalSearchResultsInitial;
    }
    default:
      return state;
  }
};

const CarRentalFiltersInitial = {
  budget: [0, 1],
  passengers: "",
  provider: "",
  car_model: "",
  num_of_doors: "",
  transmission: "",
  air_condition: "",
  order_by: "PRD",
};
export const CarRentalFilters = (state = CarRentalFiltersInitial, action) => {
  switch (action.type) {
    case CAR_RENTAL_FILTERS_RESET: {
      return CarRentalFiltersInitial;
    }
    case CAR_RENTAL_SINGLE_FILTER_RESET: {
      const { key } = action;
      return { ...state, [key]: CarRentalFiltersInitial[key] };
    }
    case CAR_RENTAL_FILTERS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case CAR_RENTAL_FILTERS_UPDATE: {
      const { filters } = action;
      return filters;
    }
    default:
      return state;
  }
};

const CarRentalSelectedInitial = {
  car_rental: {},
  session_id: "",
  loading: false,
  failed: false,
};
export const CarRentalSelected = (state = CarRentalSelectedInitial, action) => {
  switch (action.type) {
    case SELECTED_CAR_RENTAL_LOADING: {
      return { ...state, loading: true };
    }
    case SELECTED_CAR_RENTAL_IDLE: {
      return { ...state, loading: false };
    }
    case SELECTED_CAR_RENTAL_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SELECTED_CAR_RENTAL_UPDATE: {
      const { data } = action;
      return { ...state, ...data };
    }
    case SELECTED_CAR_RENTAL_RESET: {
      return CarRentalSelectedInitial;
    }
    default:
      return state;
  }
};
